import { Component, inject } from '@angular/core';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-verification-complete',
  standalone: false,
  templateUrl: './verification-complete.component.html',
  styleUrl: './verification-complete.component.scss'
})
export class VerificationCompleteComponent {

  private auth = inject(AuthService);

  login() {
    this.auth.login();
  }

}
